import Cookies from 'js-cookie';
import { helper } from '@blofin/blofin-utils';
const { isLocalhostInSafari } = helper;

const saveLang = (lang: string) => {
  Cookies.set('lang', lang, { sameSite: 'none', secure: isLocalhostInSafari() ? false : true });
};

const getLang = () => {
  return Cookies.get('lang');
};

const removeLang = () => {
  Cookies.remove('lang');
};

export { saveLang, getLang, removeLang };
